import React from 'react';
import { 
  Typography, 
  Container, 
  Box, 
  Grid, 
  Card, 
  CardContent, 
  Divider,
  Avatar
} from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';
import PeopleIcon from '@mui/icons-material/People';
import TimelineIcon from '@mui/icons-material/Timeline';

const About = () => {
  const teamMembers = [
    {
      name: "Ahmet Yılmaz",
      title: "Veri Bilimi Direktörü",
      description: "15+ yıl veri analitiği ve yapay zeka deneyimi"
    },
    {
      name: "Ayşe Kaya",
      title: "Yapay Zeka Uzmanı",
      description: "Makine öğrenimi ve derin öğrenme modellemesi uzmanı"
    },
    {
      name: "Mehmet Demir",
      title: "Yazılım Geliştirme Lideri",
      description: "Kurumsal yazılım çözümleri ve sistem entegrasyonları"
    },
    {
      name: "Zeynep Öztürk",
      title: "Veri Mühendisi",
      description: "Büyük veri altyapıları ve veri işleme sistemleri"
    }
  ];

  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 6 }}>
        <Typography variant="h3" component="h1" gutterBottom align="center">
          Hakkımızda
        </Typography>
        <Typography variant="h6" paragraph align="center" color="text.secondary">
          Verilerinizi değere dönüştüren yapay zeka ve veri analitiği çözümleri
        </Typography>
        <Divider sx={{ my: 4 }} />
      </Box>

      <Grid container spacing={6}>
        <Grid item xs={12} md={6}>
          <Typography variant="h4" gutterBottom>
            Biz Kimiz?
          </Typography>
          <Typography variant="body1" paragraph>
            D-CAT Analytics, işletmelerin verilerinden değer üreten yapay zeka ve veri analitiği 
            çözümleri geliştiren yenilikçi bir teknoloji şirketidir. 2015 yılında kurulan şirketimiz, 
            farklı sektörlerde yüzlerce başarılı projeye imza atmıştır.
          </Typography>
          <Typography variant="body1" paragraph>
            Deneyimli veri bilimcilerimiz, yapay zeka uzmanlarımız ve yazılım geliştiricilerimizden 
            oluşan ekibimiz, en güncel teknolojileri kullanarak müşterilerimizin iş sorunlarına 
            özel çözümler geliştiriyoruz.
          </Typography>
          <Typography variant="body1">
            Müşterilerimizin rekabet avantajı elde etmesini, maliyetlerini azaltmasını ve 
            gelirlerini artırmasını sağlayan veri odaklı çözümler sunmak temel hedefimizdir.
          </Typography>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Card elevation={3}>
            <CardContent>
              <Typography variant="h5" gutterBottom>
                Değerlerimiz
              </Typography>
              <Box sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                        <BusinessIcon />
                      </Avatar>
                      <Typography variant="subtitle1">
                        Yenilikçilik
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                        <TimelineIcon />
                      </Avatar>
                      <Typography variant="subtitle1">
                        Veri Odaklılık
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                        <EmojiObjectsIcon />
                      </Avatar>
                      <Typography variant="subtitle1">
                        Çözüm Odaklılık
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                      <Avatar sx={{ bgcolor: 'primary.main', mr: 2 }}>
                        <PeopleIcon />
                      </Avatar>
                      <Typography variant="subtitle1">
                        Müşteri Memnuniyeti
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid item xs={12}>
          <Typography variant="h4" gutterBottom sx={{ mt: 4 }}>
            Ekibimiz
          </Typography>
          <Grid container spacing={3}>
            {teamMembers.map((member, index) => (
              <Grid item xs={12} sm={6} md={3} key={index}>
                <Card elevation={2}>
                  <CardContent>
                    <Avatar sx={{ width: 64, height: 64, mx: 'auto', mb: 2, bgcolor: 'primary.main' }}>
                      {member.name.charAt(0)}
                    </Avatar>
                    <Typography variant="h6" align="center">
                      {member.name}
                    </Typography>
                    <Typography variant="subtitle1" color="primary" align="center">
                      {member.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 1 }}>
                      {member.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default About;
